export const EMAIL_CONTACT_TABLE = "email-contacts"
export const EMAIL_CONTACT_TABLE_SCHEMA =
  "id, companyId, emailAddress, domain, emailAccountId, syncId"
